import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';

import 'Components/HomePage/PublisherCarousel.scss';

import PublisherBox from 'Components/HomePage/PublisherBox';
import SiteSlider from 'Components/Utility/SiteSlider/SiteSlider';

const CarouselArrow = ({ className, onClick, ariaLabel, arrowDirection }) =>
  <div className={`arrow-btn-container btn-${arrowDirection}`}>
    <button className={className} aria-label={ariaLabel} onClick={onClick}>
      <FontAwesomeIcon icon={`chevron-${arrowDirection}`} />
    </button>
  </div>;

CarouselArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  arrowDirection: PropTypes.string,
};

CarouselArrow.defaultProps = {
  className: '',
  onClick: null,
  ariaLabel: 'Next',
  arrowDirection: 'right',
};

const PublisherCarousel = ({ publishers, lazyLoad, showDealNumbers, type, needsContainer }) => {
  let cleanPublishers = (publishers ?? []).filter(p => p.pub !== 'ea' && p.pub !== 'ubisoft' && p.pub !== 'square enix');

  if (type === 'fantasyverse') {
    cleanPublishers = [
      { pub: 'dark horse comics' },
      { pub: 'medibang inc' },
      { pub: 'american mythology' },
      { pub: 'z2 comics' },
      { pub: 'dark wave' },
      { pub: 'T PUB LTD' },
      { pub: 'karl drinkwater' },
      { pub: 'austin dragon' },
      { pub: 'michael la ronn' },
      { pub: 'katie cross' },
      { pub: 'boss fight books' },
      { pub: 'nbm publishing' },
      { pub: 'an inkwell of nectar' },
      { pub: 'cg harris' },
    ];
  }

  const sliderSettings = {
    xs: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    sm: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    md: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
    lg: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
    xl: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
    xxl: {
      slidesToShow: 5,
      slidesToScroll: 5,
    },
  };

  return (
    <>
      <section className={classNames({ container: needsContainer })}>
        <div className="section-heading-container">
          <h2 className="section-title">
            {type === 'game' &&
              <FormattedMessage id="publishers.title" defaultMessage="Official Partners" />
            }
            {type === 'fantasyverse' &&
              <FormattedMessage id="publishers.title.fantasyverse" defaultMessage="Official FantasyVerse Partners" />
            }
          </h2>
        </div>

        {isEmpty(cleanPublishers) &&
          <SiteSlider sliderSettings={sliderSettings} sliderClass="PublisherCarousel">
            {[...Array(8).keys()].map(i =>
              <div className="publisher-box-container" key={i + 1}>
                <div className="publisher-box" />
              </div>,
            )}
          </SiteSlider>
        }
        {cleanPublishers &&
          <SiteSlider sliderSettings={sliderSettings} sliderClass="PublisherCarousel">
            {cleanPublishers.slice(0, 15).map((publisher, index) =>
              <div className="publisher-box-container" key={`${publisher.pub}`}>
                <PublisherBox
                  publisherCarousel
                  lazyLoad={lazyLoad}
                  publisher={publisher.pub}
                  discounts={publisher.discounts}
                  showDealNumbers={showDealNumbers}
                  index={index + 1}
                />
              </div>,
            )}
          </SiteSlider>
        }
      </section>
    </>
  );
};

PublisherCarousel.propTypes = {
  publishers: PropTypes.arrayOf(PropTypes.shape({})),
  lazyLoad: PropTypes.bool,
  showDealNumbers: PropTypes.bool,
  needsContainer: PropTypes.bool,
  type: PropTypes.string,
};

PublisherCarousel.defaultProps = {
  publishers: [],
  lazyLoad: true,
  showDealNumbers: false,
  needsContainer: true,
  type: 'game',
};

const mapStateToProps = ({
  publishers: {
    ranking,
  },
}) => ({
  publishers: ranking,
});

export default connect(mapStateToProps, null)(PublisherCarousel);
